/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationSharedPromoCodesRedeemPromoCodeResult } from './FxIdApplicationSharedPromoCodesRedeemPromoCodeResult';
import {
    FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSON,
    FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSONTyped,
    FxIdApplicationSharedPromoCodesRedeemPromoCodeResultToJSON,
    FxIdApplicationSharedPromoCodesRedeemPromoCodeResultToJSONTyped,
} from './FxIdApplicationSharedPromoCodesRedeemPromoCodeResult';
import type { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
import {
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped,
} from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';

/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult
 */
export interface FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult {
    /**
     * 
     * @type {boolean}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult
     */
    Success: boolean;
    /**
     * 
     * @type {FxIdApplicationSharedPromoCodesRedeemPromoCodeResult}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult
     */
    Data: FxIdApplicationSharedPromoCodesRedeemPromoCodeResult;
    /**
     * 
     * @type {FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult
     */
    Error?: FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError | null;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult(value: object): value is FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult {
    return FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Data': FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultToJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult {
    return FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Data': FxIdApplicationSharedPromoCodesRedeemPromoCodeResultToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}

